import React from 'react';
import styles from './SkeletonCard.module.scss';

/**
 * Skeleton loading card component
 * Displays a placeholder card with shimmer animation while products load
 */
export default function SkeletonCard() {
    return (
        <article className={styles.skeleton}>
            <div className={styles.imageContainer}>
                <div className={`${styles.image} ${styles.shimmer}`}></div>
            </div>
            <div className={styles.content}>
                <div className={`${styles.latinName} ${styles.shimmer}`}></div>
                <div className={`${styles.title} ${styles.shimmer}`}></div>
                <div className={`${styles.description} ${styles.shimmer}`}></div>
                <div className={`${styles.descriptionLine} ${styles.shimmer}`}></div>
                <div className={styles.spacer}></div>
                <div className={styles.priceAndButton}>
                    <div className={`${styles.button} ${styles.shimmer}`}></div>
                </div>
            </div>
        </article>
    );
}
